import React, { Component } from 'react'
import { MappingAgeConsumer } from '../../../../context/MappingAgeContext'
import { MappingAgeRangeConsumer } from '../../../../context/MappingAgeRangeContext'
import { MappingBreedConsumer } from '../../../../context/MappingBreedContext'
import { MappingSexConsumer } from '../../../../context/MappingSexContext'
import { MappingStateConsumer } from '../../../../context/MappingStateContext'
import { MappingSizeConsumer } from '../../../../context/MappingSizeContext'
import { MappingSpecieConsumer } from '../../../../context/MappingSpecieContext'
import { MappingCharacteristicConsumer } from '../../../../context/MappingCharacteristicContext'
import { MappingColorConsumer } from 'context/MappingColorContext'
import { ShelterProvider } from 'context/ShelterContext'
import { CountryProvider } from 'context/CountryContext'
import { SpecieProvider } from 'context/SpecieContext'
import { BreedProvider } from 'context/BreedContext'
import { AgeProvider } from 'context/AgeContext'
import { SexProvider } from 'context/SexContext'
import { SizeProvider } from 'context/SizeContext'
import { CharacteristicsProvider } from 'context/CharacteristicsContext'
import { IntegrationProvider } from 'context/IntegrationContext'
import { MappingBranchConsumer } from 'context/MappingBranchContext'

type WrapperMappingDataProps = {
  activeTab: string,
  children: any,
}

export default class WrapperMappingData extends Component<WrapperMappingDataProps> {
  render() {
    return (<>
      <ShelterProvider>
        <SpecieProvider>
          <BreedProvider>
            <AgeProvider>
              <SexProvider>
                <SizeProvider>
                  <CharacteristicsProvider>
                    <CountryProvider>
                      <IntegrationProvider>
                        {this.renderContent()}
                      </IntegrationProvider>
                    </CountryProvider>
                  </CharacteristicsProvider>
                </SizeProvider>
              </SexProvider>
            </AgeProvider>
          </BreedProvider>
        </SpecieProvider>
      </ShelterProvider>
    </>)
  }

  renderContent() {
    const { activeTab, children } = this.props

    switch(activeTab) {
      case 'age':
        return (
          <MappingAgeConsumer>
            {({ mappingAge, fetching, requestMappingAgeList, requestMappingAgeFind, requestMappingAgeSave }) => {
              // Parser age relation
              if (mappingAge) {
                mappingAge = {
                  ...mappingAge,
                  shelter_uuid: mappingAge.shelter_uuid ?? mappingAge.shelter?.uuid,
                }
              }
              return children({ values: mappingAge, loading: fetching, listMappings: requestMappingAgeList, loadMapping: requestMappingAgeFind, saveMapping: requestMappingAgeSave })
            }}
          </MappingAgeConsumer>
        )
      case 'age-range':
        return (
          <MappingAgeRangeConsumer>
            {({ mappingAgeRange, fetching, requestMappingAgeRangeList, requestMappingAgeRangeFind, requestMappingAgeRangeSave }) => {
              if (mappingAgeRange && mappingAgeRange.specie) {
                mappingAgeRange = {
                  ...mappingAgeRange,
                  specie_uuid: mappingAgeRange.specie.uuid
                }
              }

              return children({ values: mappingAgeRange, loading: fetching, listMappings: requestMappingAgeRangeList, loadMapping: requestMappingAgeRangeFind, saveMapping: requestMappingAgeRangeSave })
            }}
          </MappingAgeRangeConsumer>
        )
      case 'breed':
        return (
          <MappingBreedConsumer>
            {({ mappingBreed, fetching, requestMappingBreedList, requestMappingBreedFind, requestMappingBreedSave }) => {
              // Parser breed relation
              if (mappingBreed) {
                mappingBreed = {
                  ...mappingBreed,
                  breed_uuid: mappingBreed.breed_uuid ?? mappingBreed.breed?.uuid,
                  specie_uuid: mappingBreed.specie_uuid ?? mappingBreed.specie?.uuid,
                  shelter_uuid: mappingBreed.shelter_uuid ?? mappingBreed.shelter?.uuid,
                }
              }

              return children({ values: mappingBreed, loading: fetching, listMappings: requestMappingBreedList, loadMapping: requestMappingBreedFind, saveMapping: requestMappingBreedSave })
            }}
          </MappingBreedConsumer>
        )
      case 'sex':
        return (
          <MappingSexConsumer>
            {({ mappingSex, fetching, requestMappingSexList, requestMappingSexFind, requestMappingSexSave }) => {
              // Parser sex relation
              if (mappingSex) {
                mappingSex = {
                  ...mappingSex,
                  shelter_uuid: mappingSex.shelter_uuid ?? mappingSex.shelter?.uuid,
                }
              }
              return children({ values: mappingSex, loading: fetching, listMappings: requestMappingSexList, loadMapping: requestMappingSexFind, saveMapping: requestMappingSexSave })
            }}
          </MappingSexConsumer>
        )
      case 'state':
        return (
          <MappingStateConsumer>
            {({ mappingState, fetching, requestMappingStateList, requestMappingStateFind, requestMappingStateSave }) => {
              // Parser state relation
              if (mappingState) {
                mappingState = {
                  ...mappingState,
                  country_uuid: mappingState.state?.country?.uuid ?? mappingState.country?.uuid,
                  state_uuid: mappingState.state?.uuid ?? mappingState.state_uuid,
                  shelter_uuid: mappingState.shelter_uuid ?? mappingState.shelter?.uuid,
                }
              }
              return children({ values: mappingState, loading: fetching, listMappings: requestMappingStateList, loadMapping: requestMappingStateFind, saveMapping: requestMappingStateSave })
            }}
          </MappingStateConsumer>
        )
      case 'size':
        return (
          <MappingSizeConsumer>
            {({ mappingSize, fetching, requestMappingSizeList, requestMappingSizeFind, requestMappingSizeSave }) => {
              // Parser size relation
              if (mappingSize) {
                mappingSize = {
                  ...mappingSize,
                  shelter_uuid: mappingSize.shelter_uuid ?? mappingSize.shelter?.uuid,
                }
              }
              return children({ values: mappingSize, loading: fetching, listMappings: requestMappingSizeList, loadMapping: requestMappingSizeFind, saveMapping: requestMappingSizeSave })
            }}
          </MappingSizeConsumer>
        )
      case 'specie':
        return (
          <MappingSpecieConsumer>
            {({ mappingSpecie, fetching, requestMappingSpecieList, requestMappingSpecieFind, requestMappingSpecieSave }) => {
              // Parser specie relation
              if (mappingSpecie) {
                  mappingSpecie = {
                    ...mappingSpecie,
                    specie_uuid: mappingSpecie.specie_uuid ?? mappingSpecie.specie?.uuid,
                    shelter_uuid: mappingSpecie.shelter_uuid ?? mappingSpecie.shelter?.uuid,
                  }
              }

              return children({ values: mappingSpecie, loading: fetching, listMappings: requestMappingSpecieList, loadMapping: requestMappingSpecieFind, saveMapping: requestMappingSpecieSave })
            }}
          </MappingSpecieConsumer>
        )
      case 'color':
        return (
          <MappingColorConsumer>
            {({ mappingColor, fetching, requestMappingColorList, requestMappingColorFind, requestMappingColorSave }) => {
              // Parser color relation
              if (mappingColor) {
                  mappingColor = {
                    ...mappingColor,
                    shelter_uuid: mappingColor.shelter_uuid ?? mappingColor.shelter?.uuid,
                    expression: mappingColor.json?.expression,
                    description: mappingColor.json?.description,
                  }
              }

              return children({ values: mappingColor, loading: fetching, listMappings: requestMappingColorList, loadMapping: requestMappingColorFind, saveMapping: requestMappingColorSave })
            }}
          </MappingColorConsumer>
        )
      case 'branch':
        return (
          <MappingBranchConsumer>
            {({ mappingBranch, fetching, requestMappingBranchList, requestMappingBranchFind, requestMappingBranchSave }) => {
              // Parser color relation
              if (mappingBranch) {
                  mappingBranch = {
                    ...mappingBranch,
                    shelter_uuid: mappingBranch.shelter_uuid ?? mappingBranch.shelter?.uuid,
                    branch_uuid: mappingBranch.branch_uuid ?? mappingBranch.branch?.uuid,
                    expression: mappingBranch.json?.expression,
                    description: mappingBranch.json?.description,
                  }
              }

              return children({ values: mappingBranch, loading: fetching, listMappings: requestMappingBranchList, loadMapping: requestMappingBranchFind, saveMapping: requestMappingBranchSave })
            }}
          </MappingBranchConsumer>
        )
      case 'characteristic':
        return (
          <MappingCharacteristicConsumer>
            {({ mappingCharacteristic, fetching, requestMappingCharacteristicList, requestMappingCharacteristicFind, requestMappingCharacteristicSave }) => {
               // Parser characteristic relation
              if (mappingCharacteristic) {
                mappingCharacteristic = {
                  ...mappingCharacteristic,
                  characteristic_uuid: mappingCharacteristic.characteristic?.uuid,
                  shelter_uuid: mappingCharacteristic.shelter?.uuid
                }
              }
              return children({ values: mappingCharacteristic, loading: fetching, listMappings: requestMappingCharacteristicList, loadMapping: requestMappingCharacteristicFind, saveMapping: requestMappingCharacteristicSave })
            }}
          </MappingCharacteristicConsumer>
        )
      default:
        return null
    }
  }
}
